import { combineReducers } from '@reduxjs/toolkit';
// import { combineReducers } from 'redux';

import showIntroReducer from './intro';
import userTokenReducer from './user';
import loginDetailReducer from './loginDetail';
import userDetailReducer from './userDetail';
import coinDetailReducer from './coinDetailReducer';
import messageDetailReducer from './MessageReducer';
import newsDetailReducer from './NewsReducer';
import resultDetailReducer from './Result';
import languageReducer from './languageReducer';
import OpenDrawerReducer from './OpenDrawer';

const rootReducer = combineReducers({
  showIntroReducer,
  userTokenReducer,
  loginDetailReducer,
  userDetailReducer,
  coinDetailReducer,
  messageDetailReducer,
  newsDetailReducer,
  resultDetailReducer,
  languageReducer,
  OpenDrawerReducer
});

export default rootReducer;
